import { Location } from '@app/shared/routes';

export const CreatePrivacyPolicyFormLocation = new Location({
  path: '/legal/privacy-policy/create'
});
